<template>
  <div>
    <article class="vacancy-overview">
      <div class="container vacancy-overview-holder">
        <HeroesMainHero
          v-if="hero && (hero.title?.value || hero.body?.value)"
          :main-hero="{
            intro: {
              icon: hero.icon ?? null,
              title: hero.title ?? null,
              body: hero.body ?? null,
            },
            img: hero.image,
          }" />
      </div>
      <div class="content-row">
        <div class="content-block-full">
          <div class="content-row">
            <div class="content-block">
              <h1 v-if="title && title.value" v-bind="useEpiAttrs(title)">{{ title.value }}</h1>
            </div>
          </div>
          <div class="content-row block-two-column-after">
            <div class="content-block vacancy-overview">
              <BlocksVacancyBlockItem
                v-for="(job, index) in jobs"
                :key="job.link?.url ?? index"
                :title="job.title ?? ''"
                :body="job.summary ?? ''"
                :link="job.link?.url ?? ''" />
            </div>
          </div>
          <div class="content-row">
            <div class="content-block two-column-text">
              <BlocksWerkenbijContentArea v-if="body" :content="body" />
            </div>
          </div>
          <div class="content-row">
            <div class="content-block">
              <BlocksWerkenbijContentArea v-if="body2" :content="body2" />
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script lang="ts" setup>
import type { ContentResponseModel, JobOverviewPageResponseModel } from '@api';

const props = defineProps<{ data: ContentResponseModel }>();
const { title, body, hero, jobs, body2 } = props.data.content as JobOverviewPageResponseModel;
</script>

<style lang="scss" scoped>
.vacancy-overview {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;

  h1 {
    color: var(--color-navy-blue);
  }

  .block-two-column-after {
    padding: 0 0 px(30);
  }

  .two-column-text {
    :deep(p) {
      margin: 0;
    }

    :deep(p ~ p) {
      margin-top: px(30);
    }

    :deep(div + p) {
      margin-top: 0;
    }
  }
}
</style>
